import React from "react";
import * as BiIcons from "react-icons/bi";
import * as parametrosActions from "../../../../../../store/modules/personas/parametros_store/actions";
import * as controller from "../../../../../../controllers/personasController/parametrosController";
import { useSelector } from "react-redux";
import { notifySuccess } from "../../../../../../components/message/message";

function TableCredencial({ integracao, isIntegracao = false }) {
  const { seeRegister, id_integracao } = useSelector(
    (state) => state.personasParametros
  );
  const { tipoLoja } = useSelector((state) => state.personasPapeis);
  const data = integracao;

  async function handleRemoveItem(parametro) {
    var isValid = await controller.deleteIntegracao(
      parametro,
      tipoLoja?.id,
      id_integracao
    );
    if (isValid) {
      notifySuccess("Integração excluída com sucesso!");
    }
  }

  async function handleGetItem(item) {
    parametrosActions.setItem(item);
  }
  return (
    <>
      <table style={{ marginTop: "20px", width: "95%", marginLeft: "2%" }}>
        <thead>
          <tr>
            <th>Plataforma</th>
            <th>URL</th>
            <th style={{ textAlign: "center" }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            return (
              <>
                <tr>
                  <td>{row.descricao ?? ""}</td>
                  <td>{row.url || ""}</td>
                  <td style={{ textAlign: "center" }}>
                    <>
                      {!seeRegister && (
                        <BiIcons.BiEdit
                          style={{
                            fontSize: "1.2rem",
                            cursor: "pointer",
                            color: "#C4C7CA",
                          }}
                          onClick={() => {
                            handleGetItem(row);
                          }}
                        />
                      )}
                    </>
                    <>
                      {!seeRegister && (
                        <BiIcons.BiTrash
                          style={{
                            fontSize: "1.2rem",
                            cursor: "pointer",
                            color: "#C4C7CA",
                          }}
                          onClick={() => {
                            handleRemoveItem(row);
                          }}
                        />
                      )}
                    </>
                  </td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

export default TableCredencial;
